export default __webpack_public_path__ + "static/media/warning.7327ca9b.svg";